import React, { useMemo } from 'react';
import styles from './AvatarModal.module.scss';
import cx from 'classnames';
import Icon from '../../../../components/Icon/Icon';
import * as Icons from '../../../../components/FlagIcons/FlagIcons';


const AvatarVoicePreview = ({ voice, onSelect, selected, currentPlayingVoiceId, playPauseVoice }) => {

    const languageIcon = useMemo(() => {
        if (!voice.language) return null;
        const lowerCaseLanguage = voice.language.toLowerCase();
        if (lowerCaseLanguage === 'dutch' || lowerCaseLanguage.includes('nl')) {
            return 'dutch';
        }
        return 'english';
    }, [voice.language]);
    const name = useMemo(() => voice.name.split(/[_\ - ]/)[0], [voice.name]);


    return <div onClick={() => onSelect(voice.voice_id)} className={cx(styles.voicePreview, { [styles.selected]: selected })} aria-selected={selected} tabIndex={selected ? 0 : -1}>
        <button onClick={() => playPauseVoice(voice.voice_id)} className={styles.playPauseButton}>
            <Icon
                src={currentPlayingVoiceId === voice.voice_id ? 'musicPause' : 'musicPlay'}
                className={styles.actionIcon}
                verticalAlign="middle"
            />
        </button>
        <div className={styles.infoWrapper}>
            <p className={styles.name}>{name}</p>
            {languageIcon && <Icon src={languageIcon} className={cx(styles.languageIcon)} IconsSource={Icons} />}
            <Icon src="musicWaveform" className={cx(styles.waveformIcon, { [styles.show]: currentPlayingVoiceId === voice.voice_id })} verticalAlign="middle" />
        </div>
    </div>
}

export default AvatarVoicePreview;